import { render, staticRenderFns } from "./ClawMachine.vue?vue&type=template&id=4921a5d5&scoped=true&"
import script from "./ClawMachine.vue?vue&type=script&lang=js&"
export * from "./ClawMachine.vue?vue&type=script&lang=js&"
import style0 from "./ClawMachine.vue?vue&type=style&index=0&id=4921a5d5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4921a5d5",
  null
  
)

export default component.exports